import { Icon } from "@iconify/react/dist/iconify.js";
import { login } from '../utils/api';
import React, { useState } from "react";
import { Link,useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const SignInPage = () => {

  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if(!formData?.email){
       toast.error('This Email Required');
       return;
    }
    if(!formData?.password){
      toast.error('This Passowrd Required');
      return;
   }
    try {
      const responce = await login(formData);
      localStorage.setItem('token', responce.token);
      localStorage.setItem('activeUser', JSON.stringify(responce));
      toast.success('You have successfully signed in');
      
      navigate(responce.user_type+'/dashboard');
    } catch (error) {
      toast.error('Login failed: ' + error.message);
    }
  };
 
  return (
    <section className='auth bg-base d-flex flex-wrap'>
      <div className='auth-left d-lg-block d-none'>
        <div className='d-flex align-items-center flex-column justify-content-center'>
          <img src='assets/images/auth/admin-front.jpg' className="w-100" alt='' />
        </div>
      </div>
      <div className='auth-right d-flex flex-column justify-content-center'>
        <div className='max-w-464-px mx-auto p-3 w-100'>
          <div>
            <Link to='/' className='mb-40 max-w-290-px'>
              <img src='assets/images/logo.png' alt='' />
            </Link>
          </div>
          <ToastContainer></ToastContainer>
          <form onSubmit={handleSubmit}>
            <div className='icon-field mb-16'>
              <span className='icon top-50 translate-middle-y'>
                <Icon icon='mage:email' />
              </span>
              <input
                type='email'
                className='form-control h-56-px bg-neutral-50 radius-12'
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                placeholder='Email'
              />
            </div>
            <div className='position-relative mb-20'>
              <div className='icon-field'>
                <span className='icon top-50 translate-middle-y'>
                  <Icon icon='solar:lock-password-outline' />
                </span>
                <input
                  type='password'
                  className='form-control h-56-px bg-neutral-50 radius-12'
                  id='your-password'
                  placeholder='Password'
                  value={formData.password}
                  onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                />
              </div>
            </div>
            <button
              type='submit'
              className='btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32'>
              {" "}
              Sign In
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default SignInPage; 
